module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (169).3140abf9.jpg";